var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-table',{attrs:{"url":"/api/v1/moderatorSupportMessage","filter":[
    {
      name: 'with',
      value: 'user'
    }
  ],"attributes":[
    {
      attribute: 'id',
      name: 'ID'
    },
    {
      name: 'Moderator',
      attribute: 'user',
      type: 'UserCell',
      sortable: false
    },
    {
      name: 'Nachricht',
      attribute: 'message',
      type: 'SupportShortendMessageCell'
    },
    {
      name: 'Eingegangen',
      attribute: 'created_at',
      type: 'DateTimeCell'
    },
    {
      name: 'Status',
      attribute: 'read',
      type: 'ToggleCell',
      url: 'read_toggle_url'
    },
    {
      name: 'Bearbeitung',
      type: 'SupportReadByCell'
    }
  ]}})}
var staticRenderFns = []

export { render, staticRenderFns }